import React, { Fragment, useEffect, useContext, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { observer, useObserver } from "mobx-react-lite";
import Grid from "@material-ui/core/Grid";

/* container */
import CMSContainer from "../../app-module-cms-container/default";
/* container */

/* packages */
import { GlobalContext } from "../../lib-atomic-context";
import {
  ModuleContainerLg,
  ModuleFormWrapper,
  ModuleFormItemWrapper,
  ModulePaddedWrapperLg,
  ModulePaperWrapper,
  ModuleTitle,
  ModuleText,
  ModuleTextBold,
} from "../../lib-atomic-design-section";
import { Buttons } from "../../lib-atomic";
/* packages */

/* module */
import CMSActivateHeader from "../../app-module-cms-section-activate-header/default";
/* module */

const index = observer((props) => {
  const { registeractivation } = useContext(GlobalContext);
  const isRegistrationActivation =
    registeractivation.state.data.registrationactivationobj.outcomeCode === "0"
      ? true
      : false;
  const isAlreadyActivated =
    registeractivation.state.data.registrationactivationobj.outcomeCode ===
    "EMR:ACT_USR:4"
      ? true
      : false;

  const handleBack = () => {
    props.history.push("/corporate/register");
  };
  const handleForward = () => {
    props.history.push("/corporate/login");
  };
  /* data props */
  const backButton = { size: "medium", onClick: handleBack };
  const forwardButton = { size: "medium", onClick: handleForward };
  // if (!warning) setWarning("Card Number, Reference Number or Invoice Number not valid.")
  return (
    <Fragment>
      <ModuleFormItemWrapper>
        <ModulePaperWrapper>
          {isRegistrationActivation && (
            <ModuleTitle>Account Activation Succcessful</ModuleTitle>
          )}
          {!isRegistrationActivation && (
            <ModuleTitle>Account Activation Unsucccessful</ModuleTitle>
          )}

          {/* content wording : false */}
          {!isRegistrationActivation && isAlreadyActivated && (
            <ModuleText>Account has already been activated</ModuleText>
          )}

          {/* content wording : false */}
          {!isRegistrationActivation && !isAlreadyActivated && (
            <ModuleText>Please contact our suppport</ModuleText>
          )}

          {/* content wording */}
          {isRegistrationActivation && (
            <ModuleText>You can now login using your account.</ModuleText>
          )}

          <br />
          <ModuleFormWrapper>
            <ModuleFormItemWrapper>
              {!isRegistrationActivation && (
                <Buttons.Normal {...backButton}>BACK</Buttons.Normal>
              )}
              {isRegistrationActivation && (
                <Buttons.Normal {...forwardButton}>
                  Continue to login
                </Buttons.Normal>
              )}
            </ModuleFormItemWrapper>
          </ModuleFormWrapper>
        </ModulePaperWrapper>
      </ModuleFormItemWrapper>
    </Fragment>
  );
});

export default index;
